import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

export function validateRegex(c: FormControl, regex: RegExp | string) {
  if (!(regex instanceof RegExp)) {
    regex = new RegExp(regex);
  }

  return regex.test(c.value) ? null : {
    validExpr: {
      valid: false
    }
  };
}

@Directive({
  selector: '[validExpr][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbRegexValidator, multi: true}
  ]
})
export class JbRegexValidator implements Validator {
  @Input()
  public validExpr: RegExp | string;

  public validate(c: FormControl): ValidationErrors | any {
    return validateRegex(c, this.validExpr);
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/regex.validator.ts